import { installPenRecordStore } from '@/utils/penBridge/recordStore'
import wzbPenBridge from '@/utils/penBridge/wzb'

const bridges = []
let installed = false
let callbackQueue = Promise.resolve()

// 笔型适配器只需实现 { name, matches(response), handle(response) }。

function parseBase64Object(base64Str) {
  try {
    return JSON.parse(decodeURIComponent(escape(window.atob(base64Str))))
  } catch (error) {
    try {
      return JSON.parse(window.atob(base64Str))
    } catch (fallbackError) {
      console.log('pen response parse failed', error, fallbackError)
      return null
    }
  }
}

function findBridge(response) {
  return bridges.find(bridge => {
    try {
      return bridge.matches(response)
    } catch (error) {
      console.log(`${bridge.name} pen response match failed`, error)
      return false
    }
  })
}

function handlePenInfo(base64Str) {
  const response = parseBase64Object(base64Str)
  if (!response) return

  const bridge = findBridge(response)
  if (!bridge) return
  callbackQueue = callbackQueue
    .then(() => bridge.handle(response))
    .catch(error => {
      console.log(`${bridge.name} pen response handle failed`, error)
    })
}

export function registerPenBridge(bridge) {
  if (!bridge || !bridge.name || typeof bridge.matches !== 'function' || typeof bridge.handle !== 'function') {
    throw new Error('Invalid pen bridge')
  }
  const index = bridges.findIndex(item => item.name === bridge.name)
  if (index === -1) bridges.push(bridge)
  else bridges.splice(index, 1, bridge)
}

registerPenBridge(wzbPenBridge)

export function installPenNativeBridge() {
  if (typeof window === 'undefined' || installed) return
  installed = true
  installPenRecordStore()
  window.__trPenNativeGetPenInfo = handlePenInfo
  window.getPenInfo = handlePenInfo
}
